export const color = {
  black: "#000000",
  primary: "#1C2B49",
  white: "#fff",
  error: "#C25A3F",
  error100: "#EDDEDE",
  gray100: "#F8FAFB", // notification background
  gray300: "#E1E1E1", //  input border
};
